import React from "react";
import styled, { keyframes } from 'styled-components';
import { breakpoints } from '../../utils/styles';

const ScrollBt = styled.div`
    display: none;
    cursor: pointer;

    @media screen and (min-width: ${breakpoints.tablet}px) {  
        display: block;
        bottom: 0px;
        width: 100%;
        text-align: center;
        padding: 0.75em 0.5em;
    }
    @media screen and (min-width: ${breakpoints.desktopLarge}px) {
        padding: 1em 0.5em;
    }
`;

const ScrollText = styled.span`
    display: none;

    @media screen and (min-width: ${breakpoints.tablet}px) { display: inline; }
`;

const ScrollArrAnimation = keyframes`
    from {
        transform: translateY(-0.35em);
    }

    to {
        transform: translateY(0.15em);
    }
`;

const ScrollArr = styled.em`
    color: var(--primary);
    margin-left: 0.5em;
    animation: ${ScrollArrAnimation} 1s linear infinite alternate;
`;

const scrollTo = scrollToOptions => {
    const isSmoothScrollSupported = 'scrollBehavior' in document.documentElement.style;

    if (isSmoothScrollSupported) {
        window.scroll(scrollToOptions);
    } else {
        window.scroll(scrollToOptions.left || 0, scrollToOptions.top || 0);
    }
};

const onScrollClick = () => {
    const elem = document.querySelector('#home-feat-movie');
    if (!elem) return;
    const t = elem.getBoundingClientRect().height - 72;
    scrollTo({ top: t, behavior: 'smooth' });
};

function ScrollToMoviesButton() {
    return <ScrollBt onClick={onScrollClick}>
        <ScrollText>Ver cartelera</ScrollText>
        <ScrollArr className="fal fa-arrow-down" />
    </ScrollBt>
}

export default ScrollToMoviesButton;